import {
    ButtonView,
    FocusCycler,
    LabeledFieldView,
    View,
    ViewCollection,
    createLabeledInputText,
    injectCssTransitionDisabler,
    submitHandler,
    LabelView
} from 'ckeditor5/src/ui';

export class KeywordView extends View {
    constructor(locale) {
        super(locale);

        const bind = this.bindTemplate;
        const labelView = new LabelView();

        // Views define their interface (state) using observable attributes.
        this.set('value');

        this.setTemplate({
            tag: 'div',
            attributes: {
                class: [
                    'ck',
                    'ck-link-actions',
                    'ck-responsive-form'
                ],
                tabindex: '-1'
            },
            children: [
                {
                    text: bind.to('value')
                }
            ],
        });
    }

}
